
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import { SudokuGrid } from '@/sudoku/interfaces/SudokuGrid';
import cx from '@/utils/classes';

@Component
export default class Counters extends Vue {
  @Prop({ type: Object, default: () => ({}) }) public items!: SudokuGrid;

  get counters() {
    const values = Object.values(this.items);
    return Array(9)
      .fill(null)
      .map((_, i) => {
        const num = i + 1;
        const count = values.filter((x) => Number(x) === num).length;

        return {
          number: num,
          count,
          classes: cx(
            'counter',
            count === 9 && 'counter--complete',
            count > 9 && 'counter--overloaded'
          )
        };
      });
  }

  @Emit()
  public highlight(num: number) {
    // Kick up
  }

  @Emit()
  public selected(num: number) {
    // Kick up
  }
}
